import { useMutation } from "@tanstack/react-query";
import type { ProductUploadResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type CreateStoreLogoUploadIntentInput = {
  fileName: string;
  contentType: string;
  sizeBytes: number;
};

export function useCreateStoreLogoUploadIntentMutation() {
  const mutation = useMutation({
    mutationFn: (input: CreateStoreLogoUploadIntentInput) =>
      apiJsonClient<ProductUploadResponse>(endpoints.seller.storeLogoUploads, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
